import { COLOR } from 'const/color';

export const BOOKED_SHIFT_COLOR = COLOR.SHIFT_GREEN;
export const ONLINE_COLOR = '#1e90ff';
export const OFFLINE_COLOR = COLOR.GRAY;
export const ASSIGNED_COLOR = COLOR.RED;
